export default __webpack_public_path__ + "static/media/jo.751b1e31.svg";